export const environment = {
  sentryEnvironment: 'production',
  // apiHost: null,
  apiHost: 'https://libertea.sencha-tea.com',
  enableImageTransforms: true,
  production: true,
  stripePublishableKey: 'pk_live_51Qd0QNRq0dcLg4aomiGZ1U3EGeNgaPV8P5ZfR9grQeyzj0uazQSFWQWpFRFj7oSHyXbQY2F3BRH4m3nm6gBW3EJx00w9LhcjLW',
  // stripePublishableKey: 'pk_test_51Qd0QY2NnarlrS83PnIbVIZGe9SRCh5jIPQX7fOI1jn87FvmoZEkBRDdRcjdmF1ZOoa6E8euLLlHDmFFHhjkDS1800qoSPT3dZ',
  transformPrefix: null,
  contactUsWorkflowUrl: 'https://n8n.truetea.link/webhook/79d10f9a-6e45-471d-890d-983b1ae58718',
  OPTIMISATION_GA: 'G-M7PG00NS3W',
  OPTIMISATION_CLARITY: 'pxnrg5tnuc',
  OPTIMASATION_OPEN_REPLAY: '7ramaaIIrDqwbnNYeXMd',
  GOOGLE_MAPS_API_KEY: 'AIzaSyCx-fpUmsENUkyGk4jDs_J0hpExiuCsWnc',

  // https://github.com/dbfannin/ngx-logger/blob/master/src/lib/types/logger-level.enum.ts
  // TRACE = 0,
  // DEBUG = 1,
  // INFO = 2,
  // LOG = 3,
  // WARN = 4,
  // ERROR = 5,
  // FATAL = 6,
  // OFF = 7
  LOGGER_LEVEL: 4 // See NgxLoggerLevel
};

/* Configuration for GrowthBook */

import { Context, InitOptions } from '@growthbook/growthbook';

export const growthBookContext: Context = {
  apiHost: 'https://gbproxy.truetea.link',
  clientKey: 'sdk-db04IE7abFPAbvly',
  enableDevMode: true,
};

export const growthBookInitOptions: InitOptions = {
  streaming: true,
  timeout: 2000,
  skipCache: true,
};

